import templeOverlay from "../assets/temple-overlay.png";
import MobileNavbar from "../components/MobileNavbar";

const palette = {
  bg: "#FFF8F0",      // same as Gallery.jsx
  ink: "#241B18",
};

export default function About() {
  return (
    <div className="relative min-h-screen w-full">
      {/* MOBILE NAVBAR */}
      <MobileNavbar />
      {/* BACKGROUND OVERLAY LAYER (same pattern as Gallery.jsx) */}
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: palette.bg,
          backgroundImage: `url(${templeOverlay})`,
          backgroundSize: "cover",       // full-page background
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          opacity: 0.18,                 // subtle, embossed effect
          mixBlendMode: "overlay",
          zIndex: 0,
        }}
      />

      {/* CONTENT LAYER (stays fully bright and crisp) */}
      <div className="relative z-10 pt-16 md:pt-0">
      <section className="relative z-10 py-12 px-6 max-w-4xl mx-auto text-center">
        <h2 className="text-3xl font-bold text-sapphire mb-6">About Us</h2>

        <p className="text-lg text-gray-800 leading-relaxed">
          Carnatic Cafe brings the rich culinary traditions of Southern Parts of India to Ontario.
          Our chefs specialize in dosas, idlis, thalis, and biryanis prepared with authentic spices
          and fresh ingredients. We are committed to cultural authenticity, sustainability,
          and warm hospitality.
        </p>
      </section>
      </div>
    </div>
  );
}
